<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          v-if="testimonials"
          color="#58595b"
          offset="0"
          title="Testimonials"
        >
          <v-data-table :headers="headers" :items="testimonials" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                style="color: #4cc7e8"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props">
              <tr @click="openBusiness(props.item)">
                <td class="text-xs">{{ props.item.business_id }}</td>
                <td class="text-xs">
                  {{ formatDate(props.item.dateCreated) }}
                </td>
                <td class="text-xs">{{ props.item.fullName }}</td>
                <td class="text-xs">{{ props.item.message }}</td>
                <td v-if="props.item.visible == 1" class="text-xs-center">
                  <v-icon color="green">mdi-eye-check</v-icon>
                </td>

                <td v-else class="text-xs-center">
                  <v-icon color="red">mdi-eye-off</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    headers: [
      {
        sortable: false,
        text: "Business ID",
        value: "business_id",
      },
      {
        sortable: true,
        text: "Date Created",
        value: "dateCreated",
      },
      {
        sortable: false,
        text: "Full Name",
        value: "fullName",
      },
      {
        sortable: false,
        text: "Message",
        value: "message",
      },
      {
        sortable: false,
        text: "Visible",
        value: "visible",
      },
    ],
  }),
  computed: {
    ...mapGetters({
      user: "user",
      testimonials: "business/testimonials",
    }),
  },
  mounted() {
    this.$store.dispatch("business/loadTestimonial");
  },
  methods: {
    openBusiness(business) {
      this.$router.push({
        path: `/admin/businesses/${business.business_id}`,
      });
    },
    utcToLocal(date) {
      var convertdLocalTime = new Date(date);
      var hourOffset = convertdLocalTime.getTimezoneOffset() / 60;
      convertdLocalTime.setHours(convertdLocalTime.getHours() + hourOffset);
      return convertdLocalTime;
    },
    formatDate(date) {
      return date.slice(0, 11);
    },
  },
};
</script>
